import { Box, Grid, Paper, Tabs, Tab, useTheme } from "@mui/material";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export default function ICUNav() {
  const { t } = useTranslation();
  const [value, setValue] = useState("/icu");
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();

  const handleChange = (event, newValue) => {
    setValue(newValue);
    navigate(newValue);
  };

  useEffect(() => {
    const path = location.pathname;
    const validPaths = [
      "/icu",
      "/icu/admissions",
      "/icu/admissions/new",
      "/icu/rounds",
    ];
    if (validPaths.includes(path)) {
      setValue(path);
    } else if (path.startsWith("/icu/admissions/")) {
      // Handle dynamic admission routes
      setValue("/icu/admissions");
    } else {
      setValue("/icu");
    }
  }, [location.pathname]);

  return (
    <Grid container maxWidth="xl">
      <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
        <Paper sx={{ padding: "10px 0px", boxShadow: "0px 0px 0px" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons
            allowScrollButtonsMobile
            sx={{
              ml: "5px",
              "& .MuiTabs-indicator": { display: "none" },
            }}
          >
            {[
              { path: "/icu", label: t("icu.nav.dashboard", "Dashboard") },
              {
                path: "/icu/admissions",
                label: t("icu.nav.admissions", "Admissions"),
              },
              {
                path: "/icu/admissions/new",
                label: t("icu.nav.new_admission", "New Admission"),
              },
              {
                path: "/icu/rounds",
                label: t("icu.nav.rounds", "Rounds"),
              },
            ].map((tab, index) => (
              <Tab
                key={index}
                style={{
                  textTransform: "capitalize",
                  fontWeight: "bold",
                  borderRadius: "10px",
                  backgroundColor:
                    value === tab.path ? theme.palette.primary.main : "white",
                  color: value === tab.path ? "white" : "black",
                }}
                label={tab.label}
                value={tab.path}
                component={NavLink}
                to={tab.path}
              />
            ))}
          </Tabs>
        </Paper>
        <Box sx={{ p: 1 }}>
          <Outlet />
        </Box>
      </Box>
    </Grid>
  );
}

